import * as React from "react";
import SearchResult from "../../_data/models/SearchResult";
import {Map} from "immutable";
import SearchResultContainer from "../containers/SearchResultContainer";

interface Props {
    styles: Map<number, SearchResult>;
    specials: Map<number, SearchResult>;
    shops: Map<number, SearchResult>;
    users: Map<number, SearchResult>;
}

const SearchTrendingComponent = (props: Props) => {
    const {styles, specials, shops, users} = props;

    return (
        <div>
            {!styles.isEmpty() &&
            <div>
                <div className="row">
                    <div className="large-12 columns">
                        <h6 className="page-lead">Popular Images</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="large-12 columns">
                        <div className="featured-image-block-grid">
                            <div className="row large-up-3 medium-up-2 small-up-1">
                                {styles.toArray().map(s => {
                                    return <SearchResultContainer key={s.id} result={s} forTrending={true}/>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }

            {!styles.isEmpty() &&
            <div className="row">
                <div className="large-12 columns">
                    <h6 className="page-lead">Popular Professionals</h6>
                    <ul className="list-block flex-container">
                        {users.toArray().map(s => {
                            return <SearchResultContainer key={s.id} result={s} forTrending={true}/>
                        })}
                    </ul>
                </div>
            </div>
            }

            {!shops.isEmpty() &&
            <div>
                <div className="row">
                    <div className="large-12 columns">
                        <h6 className="page-lead">Popular Shops</h6>
                    </div>
                </div>
                <div className="row">
                    {shops.toArray().map(s => {
                        return <SearchResultContainer key={s.id} result={s} forTrending={true}/>
                    })}
                </div>
            </div>
            }

            {!specials.isEmpty() &&
            <div>
                <div className="row">
                    <div className="large-12 columns">
                        <h6 className="page-lead">Popular Specials</h6>
                    </div>
                </div>
                <div className="row">
                    {specials.toArray().map(s => {
                        return <SearchResultContainer key={s.id} result={s} forTrending={true}/>
                    })}
                </div>
            </div>
            }
        </div>
    );
};
export default SearchTrendingComponent;


// WEBPACK FOOTER //
// ./app/client/search/components/SearchTrendingComponent.tsx